import type { LucideIcon } from "lucide-react";
import {
  BookOpen,
  BookText,
  Headphones,
  Mic,
  Monitor,
  PenLine,
  Sigma,
} from "lucide-react";
import type { ProgrammeSlug } from "./useProgramme.js";

// Single source of truth for module labels + icons across the web. Earlier
// each page duplicated these maps (Dashboard, AuthoringList, Stats,
// PlatformQuestions); HEDA triples that surface so a central module makes
// edits tractable.

export type ModuleCode =
  | "reading"
  | "writing"
  | "speaking"
  | "listening"
  | "heda_english"
  | "heda_math"
  | "heda_ict";

export const MODULE_LABELS: Record<ModuleCode, string> = {
  reading: "Reading",
  writing: "Writing",
  speaking: "Speaking",
  listening: "Listening",
  heda_english: "HEDA English",
  heda_math: "HEDA Math",
  heda_ict: "HEDA ICT",
};

export const MODULE_ICONS: Record<ModuleCode, LucideIcon> = {
  reading: BookOpen,
  writing: PenLine,
  speaking: Mic,
  listening: Headphones,
  heda_english: BookText,
  heda_math: Sigma,
  heda_ict: Monitor,
};

// Programme → module list. Kept here (not in shared) so the web doesn't
// reach into the Zod barrel; the shared package exports the same mapping
// via packages/shared/src/levels.ts for API use.
export const PROGRAMME_MODULES: Record<ProgrammeSlug, readonly ModuleCode[]> = {
  fs_english: ["reading", "writing", "speaking", "listening"],
  heda: ["heda_english", "heda_math", "heda_ict"],
};

export function modulesForProgramme(slug: ProgrammeSlug): readonly ModuleCode[] {
  return PROGRAMME_MODULES[slug] ?? [];
}

export const PROGRAMME_LEVEL_CODES: Record<ProgrammeSlug, readonly string[]> = {
  fs_english: ["E1", "E2", "E3", "L1", "L2"],
  heda: ["D1", "D2", "D3"],
};

export function levelsForProgramme(slug: ProgrammeSlug): readonly string[] {
  return PROGRAMME_LEVEL_CODES[slug] ?? [];
}
